import React from "react";

import ManageLoops from "../../components/ManageLoops";

export default function Loops() {
  return <ManageLoops />;
}
